/** The exam format the deployed product learned from spike 001's past paper on
 * 2026-09-18 (docs/superpowers/plans/evidence/1d-done-condition.md, attempt 2). Real
 * values; the landing's third proof panel. No board and no verbatim paper title: the
 * landing names no exam board (docs/decisions/2026-09-30-no-exam-board-marks-in-marketing.md). */
export const sampleProfile = {
  paper_title: "Paper 1 · Computer Science",
  command_words: [
    "Define",
    "Shade",
    "State",
    "Explain",
    "Describe",
    "Complete",
    "Write",
    "Output",
    "Correct",
  ],
  total_marks: 90,
  per_question_range: [1, 11] as [number, number],
  duration_minutes: 120,
  exemplars: 31,
  cost_usd: 0.001284,
} as const;
